module.exports = __webpack_public_path__ + "static/img/minus.2742feb8.svg";